export default {
    findRequestWithPartner(myUid, partnerCampaignId) {
        return [
            {
                bool: {
                    must: [
                        { term: { status: "accepted" }},
                        { term: { 'receiver.campaign': partnerCampaignId } }, 
                        { terms: { 'users': [myUid] } }, 
                    ]
                },
            },
            {
                bool: {
                    must: [
                        { term: { status: "accepted" }},
                        { term: { 'sender.campaign': partnerCampaignId } },
                        { terms: { 'users': [myUid] } },
                    ]
                },
            },
        ]
    },


    findPendingRequestWithPartner(campaignsIds) {
        return [
            {
                bool: {
                    must: [
                        {terms: { 'campaigns': [campaignsIds]}}
                    ]
                }
            }
        ]
    }
} 